<template>
  <div class="flex contact-table-actions">
    <button
      v-if="canEdit"
      class="block w-full p-1 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
      @click.stop="edit">
      <font-awesome-icon :icon="['far', 'pen-to-square']"></font-awesome-icon><span class="sr-only">Edit</span>
    </button>
    <button
      class="block w-full p-1 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out">
      <font-awesome-icon :icon="['far', 'eye']"></font-awesome-icon><span class="sr-only">View</span>
    </button>
  </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPen, faTrashCan, faEye } from '@fortawesome/pro-regular-svg-icons';
library.add(faPen, faEye, faTrashCan);

export default {
  name: "TemplateTableButton",
  data() {
    return {
      eventType: ''
    }
  },
  computed: {
    canEdit() {
      if (this.data.shared && !this.$page.props.is_admin) {
        return false;
      }
      return true;
    }
  },
  methods: {
    edit() {
        this.$inertia.visit(route('template.edit', this.data.id), { method: 'get' });
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
  }
}
</script>

<style scoped>
/* .contact-table-actions {
  max-width: 40px;
} */
</style>
